import { render, staticRenderFns } from "./TabMyList.vue?vue&type=template&id=4c2090dc&scoped=true&"
import script from "./TabMyList.vue?vue&type=script&lang=js&"
export * from "./TabMyList.vue?vue&type=script&lang=js&"
import style0 from "./TabMyList.vue?vue&type=style&index=0&id=4c2090dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2090dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
